import React, { Component } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta } from '../../common'
import { Segment, Table, Loader, Dimmer } from 'semantic-ui-react'
import './CNCDictCandidatesExamples.css'

interface CNCDictCandidatesExamplesProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance,
    basePath: string,
    forms: string[]
}

interface CNCDictCandidatesExamplesState {
    loading: boolean,
    errorMsg: string,
    examples: any[]
}

const MAXLEN = 80

class CNCDictCandidatesExamples extends Component<CNCDictCandidatesExamplesProps, CNCDictCandidatesExamplesState> {

    state = {
        loading: false,
        errorMsg: '',
        examples: []
    }

    parseExamples(lines: string[]) {
        let examples: any[] = []
        for (let line of lines) {
            const parts = line.split('\t')
            examples.push({form: parts[0], left: parts[1], kwic: parts[2], right: parts[3]})
        }
        return examples
    }

    fetchExamples(path: string) {
        const { t, forms } = this.props
        this.setState({loading: true, examples: []})
        const url = 'files/'+path
        const request = {
            filter: '^('+forms.join('|')+')\t'
        }
        this.props.http.post(url, request)
            .then(response => {
                const data = response.data.data
                if (typeof(data)==='string') {
                    const examples = this.parseExamples(data.split('\n').filter((l: string) => l.trim()))
                    this.setState({examples: examples, errorMsg: '', loading: false})
                } else
                    this.setState({examples: [], errorMsg: t('Not a file.'), loading: false})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false, examples: []})
                } else {
                    console.log(err)
                    this.setState({errorMsg: t('Unknown error'), loading: false, examples: []})
                }
            })
    }

    async componentDidMount(): Promise<void> {
        const { basePath } = this.props
        const path = basePath.replace(/\.([^\.]+)\.txt/, '.priklady.txt')
        this.fetchExamples(path)
    }

    componentDidUpdate(prevProps: Readonly<CNCDictCandidatesExamplesProps>, prevState: Readonly<CNCDictCandidatesExamplesState>, snapshot?: any): void {
        if (this.state.loading) return
        if (this.props.basePath !== prevProps.basePath || this.props.forms.toString() !== prevProps.forms.toString()) {
            const path = this.props.basePath.replace(/\.([^\.]+)\.txt/, '.priklady.txt')
            this.fetchExamples(path)
        }
    }

    render() {
        const {examples, loading, errorMsg} = this.state

        if (loading)
            return (
                <Segment className="candidate_examples">
                    <Dimmer active>
                        <Loader/>
                    </Dimmer>
                </Segment>
            )
        else if (!examples.length)
            return (null)
        else
            return(
                <Segment className="candidate_examples">
                <Table compact basic="very">
                    <Table.Body>
                        {examples.map((conc: any) => {
                            const left = conc.left.length > MAXLEN ? conc.left.substring(conc.left.length-MAXLEN, conc.left.length) : conc.left
                            return (
                            <Table.Row>
                                <Table.Cell textAlign='right'>
                                    {left}
                                </Table.Cell>
                                <Table.Cell collapsing className='kwic'>
                                    {conc.kwic}
                                </Table.Cell>
                                <Table.Cell textAlign='left'>
                                    {conc.right}
                                </Table.Cell>
                            </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
                </Segment>
            )
    }
}

export default withTranslation()(CNCDictCandidatesExamples)